import { MouseEvent } from 'react';
import { useIntl } from 'react-intl';

import { Typography } from '../../../../design-system/components/typography/Typography';
import { SearchSubmissionTarget } from '../../SearchOverlay.types';
import { FallbackRow } from '../../utils/fallbackRows';

import { FallbackRowItem } from './FallbackRowItem';
import style from './SearchEmptyState.module.css';

type Props = {
    rows: FallbackRow[];
    activeIndex: number | null;
    pendingIndex: number | null;
    itemRef: (index: number, el: HTMLAnchorElement | null) => void;
    onMouseEnter: (index: number) => void;
    getOptionId: (index: number) => string;
    onSelect: (target: SearchSubmissionTarget, index: number) => void;
};

export function SearchEmptyState({
    rows,
    activeIndex,
    pendingIndex,
    itemRef,
    onMouseEnter,
    getOptionId,
    onSelect,
}: Props) {
    const { formatMessage } = useIntl();
    const hasTopDestinations = rows.some((row) => row.kind === 'top-destination');

    const handleRowClick = (
        event: MouseEvent<HTMLAnchorElement>,
        target: SearchSubmissionTarget,
        index: number,
    ) => {
        event.preventDefault();
        if (pendingIndex === null) onSelect(target, index);
    };

    return (
        <div className={style.section}>
            {hasTopDestinations ? (
                <div className={style.header}>
                    <Typography scale="primary-xs-bold" className={style.title}>
                        {formatMessage({
                            id: 'global.header.globalNav.destinations.topDestinations.world',
                        })}
                    </Typography>
                </div>
            ) : null}
            <div className={style.list}>
                {rows.map((row, index) => (
                    <FallbackRowItem
                        key={row.key}
                        row={row}
                        id={getOptionId(index)}
                        isActive={activeIndex === index}
                        isPending={pendingIndex === index}
                        isDisabled={pendingIndex !== null}
                        itemRef={(el) => itemRef(index, el)}
                        onMouseEnter={() => onMouseEnter(index)}
                        onClick={(event) => handleRowClick(event, row.target, index)}
                    />
                ))}
            </div>
        </div>
    );
}
